
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    classObject() {
      return {
        'text-h1 md:text-featured': this.blok?.type === 'featured',
        'text-h2 md:text-h1':
          this.blok?.type !== 'featured' && this.blok?.type === 'h1',
        'text-h3 md:text-h2': this.blok?.type === 'h2',
        'text-h3': this.blok?.type === 'h3',
      }
    },
    component() {
      let componentType = null

      if (this.blok.type === 'featured') componentType = 'h1'
      if (this.blok.type === 'h1') componentType = 'h1'
      if (this.blok.type === 'h2') componentType = 'h2'
      if (this.blok.type === 'h3') componentType = 'h3'

      return componentType
    },
  },
}
